import { Controller } from "@hotwired/stimulus"

// Tax IBAN prefix registry — mirrors Transactions::TaxPrefixRegistry
const TAX_PREFIXES = {
  500240: "DPH",
  500208: "Daň z príjmov FO",
  500224: "Daň z príjmov PO",
  500259: "DPFO zo závislej činnosti",
  500267: "Daň vyberaná zrážkou",
  500216: "DPFO nerezident",
  500232: "DPPO zo zahraničia",
  501120: "Zabezpečenie dane FO",
  501139: "Zabezpečenie dane PO",
  501163: "Daň z motorových vozidiel",
  501198: "Odvod z poistného",
  501219: "Daň z poistenia",
  501374: "Odvod z nadmerných príjmov",
  501366: "Solidárny príspevok",
  501382: "Osobitný odvod",
  501390: "Daň zo sladených nápojov",
  501403: "Daň z finančných transakcií",
  500689: "Vrátky"
}

const BANK_CODE = "8180"

export default class extends Controller {
  static targets = ["input", "preview", "table", "tbody", "toggleLink", "toggleIcon"]

  connect() {
    this.update()
  }

  update() {
    const oud = this.inputTarget.value.trim()
    if (/^\d{10}$/.test(oud)) {
      this.previewTarget.style.display = ""
      this.renderTable(oud)
    } else {
      this.previewTarget.style.display = "none"
      this.tableTarget.style.display = "none"
    }
  }

  toggle(event) {
    event.preventDefault()
    const isHidden = this.tableTarget.style.display === "none"
    this.tableTarget.style.display = isHidden ? "" : "none"
    this.toggleIconTarget.textContent = isHidden ? "expand_less" : "expand_more"
  }

  renderTable(oud) {
    const rows = Object.entries(TAX_PREFIXES).map(([prefix, label]) => {
      const iban = this.generateIban(prefix, oud)
      return `<tr><td>${label}</td><td class="font-monospace">${this.formatIban(iban)}</td></tr>`
    })
    this.tbodyTarget.innerHTML = rows.join("")
  }

  generateIban(prefix, oud) {
    const bban = `${BANK_CODE}${prefix}${oud}`
    const checkDigits = this.computeCheckDigits(bban)
    return `SK${checkDigits}${bban}`
  }

  computeCheckDigits(bban) {
    // S=28, K=20, 00 for check digit placeholder
    const numericString = `${bban}282000`
    const remainder = this.mod97(numericString)
    const check = 98 - remainder
    return check.toString().padStart(2, "0")
  }

  // BigInt-free mod 97 for broad compatibility
  mod97(numStr) {
    let remainder = 0
    for (let i = 0; i < numStr.length; i++) {
      remainder = (remainder * 10 + Number.parseInt(numStr[i], 10)) % 97
    }
    return remainder
  }

  formatIban(iban) {
    return iban.replace(/(.{4})/g, "$1 ").trim()
  }
}
